import {
  FETCH_TEACHER_NAVIGATION,
  SET_TEACHER_NAVIGATION,
  SET_TEACHER_NAVIGATION_PROPS,
} from "../actions/teacherTabNavActions";

export function teacherTabNavReducer(
  state = {
    loading: false,
    tab: 1,
    error: null,
    selectedAplPeriodId: null,
    selectedAplTab: 1,
  },
  action
) {
  switch (action.type) {
    case FETCH_TEACHER_NAVIGATION: {
      return { ...state };
    }
    case SET_TEACHER_NAVIGATION: {
      return { ...state, tab: action.payload.tabNr };
    }
    case SET_TEACHER_NAVIGATION_PROPS: {
      if (action.payload.propName === "selectedAplPeriod") {
        return {
          ...state,
          selectedAplPeriodId: action.payload.propVar,
        };
      } else if (action.payload.propName === "selectedAplTab") {
        return { ...state, selectedAplTab: action.payload.propVar };
      } else {
        return { ...state };
      }
    }
    default: {
      return {
        ...state,
      };
    }
  }
}
